import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { CreditType, InteractionType, LocalService, Status, TriggeredEvent, Wrappers10 } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-credit-logs',
  templateUrl: './credit-logs.component.html',
  styleUrls: ['./credit-logs.component.scss']
})
export class CreditLogsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["relationship", "paging"]; maxBodyHeight = 0;
  id: string; source: Wrappers10; ctryCode: string = ''; interactionType: InteractionType = InteractionType.None; userId = '';
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService, private router: Router, private billingManagementService: BillingManagementService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.profileManagementService.getCreditlogs(this.id, this.source ? this.source.paging : null).subscribe(result => {
      this.source = result;
    });
  }

  onRoute(key: string, strCreditType: string) {
    let creditType: CreditType = parseInt(strCreditType);
    switch (creditType) {
      case CreditType.Billing: {
        this.billingManagementService.getBusinessIdByBillingId(key).subscribe(result => {
          if (result.status == Status.Success) {
            let businessId = result.id;
            this.router.navigate(['/billing', this.ctryCode, this.userId, this.localService.isBusinessAvailable(businessId) ? InteractionType.Business : InteractionType.User, businessId, key]);
            this.activeModal.close({ event: TriggeredEvent.Close });
          }
        });
      } break;
    }
  }
}
